export default "__VITE_ASSET__B7HiU_u3__"